import React, { useEffect, useState } from 'react'
import FetchApi from '../customhooks/functionFetchApi'
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import { AiOutlineDoubleRight } from "react-icons/ai";
import { BsExclamationCircle } from "react-icons/bs";
import BarChart from './BarChart';
import PieChart from './PieChart';


// TEST ทดสอบ chat

const columns = [
  {
    name: 'TDS code',
    sortable: true,
    grow: 0.5,
    selector: row => <div>
      <div>{row.tdscode} || v.{row.revision}</div>
      {row.salerunnumber != "" ? <div>({row.salerunnumber})</div> : <div></div>}
    </div>,
  },
  {
    name: 'createdate',
    grow: 0.5,
    selector: row => row.createdate,
  },
  {
    name: 'Type',
    grow: 1,
    selector: row => row.journaltype,
  },
  {
    name: 'customer/product',
    grow: 1,
    selector: row => <div>
      <div> : {row.customername}</div>
      <div> : {row.productname}</div>

    </div>,
  },
  {
    name: 'ผู้สร้างเอกสาร',
    grow: 0.5,
    selector: row => row.createby,
  },
  {
    name: 'สถานะ',
    grow: 0.5,
    selector: row => row.statusflow,
  },
  {
    name: 'ลำดับอนุมัติ',
    grow: 0.5,
    selector: row => <div>
      อนุมัติที่ .{row.stateflow}
    </div>,
  },

];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
      backgroundColor: '#28B463'
    },
  },
  headCells: {
    style: {
      color: '#ffff',
      fontSize: '14px',
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  pagination: {
    style: {
      border: 'none',
    },
  },
};



function ShowDetailJournalById({ Id }) {
  const FetchApis = new FetchApi()

  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [datalist, setDatalist] = useState([])

  function handleShow(breakpoint) {
    DetaillistById(Id)
    setFullscreen(breakpoint);
    setShow(true);

  }

  function DetaillistById(Id) {
    // console.log(Id)
    FetchApis.FethcGet(`/reportjournal/getjournalPrerecievbyId/${Id}`).then((res) => {
      if (res) {
        setDatalist(res.data.data)

      }
    })
  }

  return (
    <>
      <Button size='sm' onClick={() => handleShow(true)} style={{ fontSize: 12 }}>
        ข้อมูล
      </Button>

      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ข้อมูลเอกสาร รอรับเอกสาร</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {datalist.length > 0 ? <DataTable
            columns={columns}
            data={datalist}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

          /> : <div></div>}
        </Modal.Body>
      </Modal>
    </>
  )
}





const Reportstatusjournalall = () => {
  const FetcApis = new FetchApi()
  const [dataprestatus, setDataprestatus] = useState([]);
  const [datarecievstatus, setDatarecievstatus] = useState([])
  const [colorcode, setColorcode] = useState('')
  const [reloading, setReloading] = useState(false)

  const [dataJournalPrint, setDataJournalPrint] = useState([])
  const [dataJournalNotPrint, setDataJournalNotPrint] = useState([])
  const [dataJourReviewList, setDataJourReviewList] = useState([])
  const [datapie, setDataPie] = useState([])

  const [namedapartlist, setNamedapartlist] = useState("")
  const [totallist, setTotallist] = useState([])


  useEffect(() => {
    setReloading(true)
    getapistatusall()
    getlistdatastep()
    getdatachartlist()
  }, [])

  function getapistatusall() {
    FetcApis.FethcGet(`/reportjournal/getstautsjournalall`).then((res) => {
      if (res) {

        setDataprestatus(res.data.data.dataprereciev[0])
        setDatarecievstatus(res.data.data.datareciev[0])

        setTimeout(() => {
          setReloading(false)
        }, 700);
      }
    })
  }

  function getlistdatastep() {
    FetcApis.FethcGet(`/reportjournal/getJournalGrouptTypelist`).then((res) => {
      if (res) {
        setDataJourReviewList(res.data.data.dataListRecieve[0])

        setDataJournalPrint(res.data.data.dataListTypeJournalPrint[0])

        setDataJournalNotPrint(res.data.data.dataListTypeJournalNotPrint[0])


        setTimeout(() => {
          setReloading(false)
        }, 700);
      }
    })
  }
  var datadapart = [];
  var datastateflow = []
  var datatotal = []
  function getdatachartlist() {

    FetcApis.FethcGet(`/reportjournal/getreportChart`).then((res) => {
      if (res) {
        var dt = res.data.data.dataPiechart[0]
        var dtc = res.data.data.databarchart[0]
        var datachart = [dt[0].totalPreReciev, dt[0].totalreciev, dt[0].totalsuccessfully]
        setDataPie(datachart)

        dtc.forEach(element => {

          datadapart.push(element.namedepart);
          datastateflow.push(element.stateflow)
          datatotal.push(element.total)
        });
        setNamedapartlist(datadapart)
        setTotallist(datatotal)

        datadapart = [];
        datastateflow = []
        datatotal = []
      }
    })
  }

  function ListUserbydepartment({ departmentId, flowstate }) {
    var userliset = dataprestatus.filter(
      (dp) => dp.departmentId == departmentId)

    return <div>
      {userliset.map((item, index) => (<div style={{ flexDirection: 'column', display: 'flex' }}>
        <label style={{ fontSize: 10 }}>- {item.approveby}</label>
      </div>
      )
      )}
    </div>
  }

  return (
    <div>
      {reloading == true ? <div className='body-center-page'>
        <Spinner
          as="span"
          animation="grow"
          variant="success"
          size={200}
          role="status"
          aria-hidden="true" /> LOADIN ....</div> :

        <div style={{ width: '100%', borderWidth: '1' }}>

          <div style={{ width: '100%', flexDirection: 'row', display: 'flex' }}>
            <div style={{ width: '50%', height: 300 }} >
              {namedapartlist != "" &&
                <BarChart namedapartlist={namedapartlist} Totallist={totallist} />}

            </div>
            <div style={{ width: 700, height: 300 }} >
              <PieChart datapie={datapie} />
            </div>
          </div>
          <div>
          </div>
          {/* <Card>
            <div style={{ width: '100%', fontSize: 18 }}><center><label>เอกสารที่ยังไม่ได้รับ</label></center></div>
            <div style={{ marginLeft: 20, padding: 10 }}>
              <div style={{ backgroundColor: '#FFA07A', width: 200, padding: 5, color: '#ffff' }}>
                <label>Flow Approved งานพิมพ์ </label>
              </div>
              <div style={{ flexDirection: 'row', display: 'flex' }}>
                {dataJournalPrint.map((item, index) =>
                  <div >
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                      <div style={{ padding: 5, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <div><AiOutlineDoubleRight /></div>
                        <div style={{
                          padding: 1,
                          marginLeft: 30,
                          alignContent: 'center',
                          justifyItems: 'center',
                          fontSize: 12,
                          backgroundColor: '#FFE4E6',
                          width: 80,
                          height: 80,
                          borderRadius: 100
                        }}
                        >
                          
                          <div style={{ fontSize: 12 }}>อนุมัติ {item.stateflow}</div>
                          <div style={{ fontSize: 12 }}>{item.namedepart}</div>
                          <div style={{ fontSize: 12 }}>Total( {item.total} )</div>
                        </div>

                      </div>
                    </div>
                    <div style={{ marginLeft: 55 }}>
                      <ListUserbydepartment departmentId={item.departmentId} flowstate={item.stateflow} />
                      <ShowDetailJournalById Id={item.stateflow}/>
                    </div>
                    
                  </div>)}
              </div>
            </div>

            <div style={{ marginLeft: 20, padding: 10 }}>
              <div style={{ backgroundColor: '#FFA07A', width: 200, padding: 5, color: '#ffff' }}>
                <label>Flow Approved งานไม่พิมพ์</label>
              </div>
              <div style={{ flexDirection: 'row', display: 'flex' }}>
                {dataJournalNotPrint.map((item, index) =>
                  <div >
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                      <div style={{ padding: 5, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <div><AiOutlineDoubleRight /></div>
                        <div style={{
                          padding: 1,
                          marginLeft: 30,
                          alignContent: 'center',
                          justifyItems: 'center',
                          fontSize: 12,
                          backgroundColor: '#DFF2FE',
                          width: 80,
                          height: 80,
                          borderRadius: 100
                        }}>

                          <div>อนุมัติ {item.stateflow}</div>
                          <div>{item.namedepart}</div>
                          <div>Total( {item.total} )</div>
                        </div>
                      </div>
                    </div>
                     <div style={{ marginLeft: 55 }}>
                        <ListUserbydepartment departmentId={item.departmentId} flowstate={item.stateflow} />
                      </div>
                  </div>)}
              </div>
            </div>
          </Card> */}

          <div>
           <label style={{backgroundColor:'#F29B9B',padding:5,borderRadius:5}}>ข้อมูล ยังไม่ได้เอกสาร</label>
            <Table style={{ fontSize: 12, width: '100%' }}>
              <thead >
                <tr >
                  <th style={{ backgroundColor: '#ece9e8' }}>#</th>
                  <th style={{ backgroundColor: '#ece9e8' }}>ผูอนุมัติ</th>
                  <th style={{ backgroundColor: '#ece9e8' }}>แผนก</th>
                  <th style={{ backgroundColor: '#ece9e8' }}>ลำดับอนุมัติ</th>
                  <th style={{ backgroundColor: '#ece9e8' }}>สถานะ</th>
                  <th style={{ backgroundColor: '#ece9e8' }}>จำนวนเอกสาร</th>
                  <th style={{ backgroundColor: '#ece9e8' }}>ดูข้อมูล</th>
                </tr>
              </thead>
              <tbody>
                {dataprestatus.map((item, i) => (
                  <tr >
                    <td style={{ borderBottomColor: '#cbc8c8' }}>{i + 1}</td>
                    <td style={{ borderBottomColor: '#cbc8c8' }}>{item.approveby}</td>
                    <td style={{ borderBottomColor: '#cbc8c8' }}>{item.departments}</td>
                    <td style={{ borderBottomColor: '#cbc8c8' }}>อนุมัติที่ .{item.stateflow}</td>
                    <td style={{ borderBottomColor: '#cbc8c8',color:'#6666E3' }}>{item.total>0&&<BsExclamationCircle color='red'/>} {item.total>0 && 'รอรับเอกสาร'}</td>
                    <td style={{ borderBottomColor: '#cbc8c8' ,color:item.total >5?'red':'#454444'}}>{item.total}</td>
                    <td style={{ borderBottomColor: '#cbc8c8' }}><ShowDetailJournalById Id={item.emcode}/></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div style={{ margin: 5 }}>
            <label style={{backgroundColor:'#9BD1F2',padding:5,borderRadius:5}}>ข้อมูล รับเรียบแล้ว</label>
            <Card style={{ width: '100%' }}>
              <Table style={{ fontSize: 12, width: '100%' }}>
                <thead >
                  <tr >
                    <th style={{ backgroundColor: '#ece9e8' }}>#</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>TDS Code</th>
                    <th style={{ backgroundColor: '#ece9e8', width: 300 }}>ประเภทเอกสาร</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>job status</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>confirm job</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>ระดับอนุมัติ</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>ชื่อผู้รับ</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>แผนก</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>วันที่รับ</th>
                    <th style={{ backgroundColor: '#ece9e8' }}>เวลาที่ใช้ / วัน</th>
                  </tr>
                </thead>
                <tbody>
                  {dataJourReviewList.map((item, i) => (
                    <tr >
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{i + 1}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.tdscode}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.NameForm}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.statusprove_Tds == 1 && <label style={{ color: 'green' }}>Proof job</label>}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.statusConfirm == 1 && <label style={{ color: 'green' }}>Approve</label>}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>อนุมัติที่ .{item.stateflow}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.empcode}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.departments}</td>
                      <td style={{ borderBottomColor: '#cbc8c8' }}>{item.recievTime}</td>
                      <td style={{ borderBottomColor: '#cbc8c8', backgroundColor: item.sumdate > 7 ? '#f96546' : '' }} >{item.sumdate} . วัน </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </div>
      }

    </div>
  )
}

export default Reportstatusjournalall